import { render, staticRenderFns } from "./HandleAppointMatter.vue?vue&type=template&id=14741236&scoped=true&"
import script from "./HandleAppointMatter.vue?vue&type=script&lang=js&"
export * from "./HandleAppointMatter.vue?vue&type=script&lang=js&"
import style0 from "./HandleAppointMatter.vue?vue&type=style&index=0&id=14741236&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14741236",
  null
  
)

export default component.exports